export default "__VITE_ASSET__5nVV69uL__"